module.exports = __webpack_public_path__ + "img/mirage-se-19.56c7f8a4.png";